import Axios from 'axios';
import { Message, Notification } from 'element-ui'
import Store from '@/store/index'
import Router from '@/router/index';

console.log(process.env);
let apiUrl = process.env.institutionConfig.baseRequestApi;
if (process.env.NODE_ENV == 'development') {
    // apiUrl = 'http://39.100.146.228:8083'
    // apiUrl = 'http://192.168.1.154:8081'
    // apiUrl = 'http://192.168.1.198:8083'
    // apiUrl = 'http://192.168.1.80:8083'
    // apiUrl = `//api.${process.env.institutionConfig.baseRequestApi}`
    // apiUrl = 'http://39.100.121.109:8080'
}
    

let Operation = {
    //常量。
    Const: {
        ApiUrl: apiUrl,
        Version: '1.0'
    },
    Variable: {
        notifyCount: 0
    },
    //网络。
    Http: {
        //Get请求。
        get: function(url, paras, fn) {
            //Body参数。
            let paramsStr = '';
            if (paras != null && paras != {}) {
                paramsStr += '?';
                for (const key in paras) {
                    paramsStr += (key + '=' + paras[key] + '&');
                }
                paramsStr = paramsStr.substring(0, paramsStr.length - 1);
            }

            let address = Operation.Const.ApiUrl + url + paramsStr;
            Axios({
                method: 'get',
                url: address,
                headers: Operation.Http.getHeader(),
                // withCredentials: true, // 跨域请求时发送 cookies by maliang
                //最大超时时间
                timeout: 600000,
                //服务端返回数据类型。
                responseType: 'json'
            }).then(function(response) {
                Operation.Http.handleResponse(response, fn);
            }).catch(function(error) {
                console.log("Axios异常：", error);
            });
        },
        //Post请求。
        post: function(url, paras, fn) {
            let address = Operation.Const.ApiUrl + url;
            Axios({
                method: 'post',
                url: address,
                headers: url.includes('findCommunitySettingsByRN')? {
                    'Content-Type': 'application/json',
                    'token': ''
                } : Operation.Http.getHeader(),
                data: paras,
                // withCredentials: true, // 跨域请求时发送 cookies by maliang
                //最大超时时间
                timeout: 600000,
                //服务端返回数据类型。
                responseType: 'json'
            }).then(function(response) {
                Operation.Http.handleResponse(response, fn);
            }).catch(function(error) {
                console.log("Axios异常：", error);
            });
        },
        //下载文件
        getFile: function(url, paras, fn) {
            let address = Operation.Const.ApiUrl + url;
            Axios({
                method: 'get',
                url: address,
                headers: Operation.Http.getHeader(),
                data: paras,
                //最大超时时间
                timeout: 600000,
                //服务端返回数据类型。
                }).then(function(response) {
                fn(response)
            })
        },
        //post发送文件
        postImgFile: function(url, paras, fn) {
            let address = Operation.Const.ApiUrl + url;
            Axios({
                method: 'post',
                url: address,
                headers: Operation.Http.getPostFileHeader(),
                data: paras,
                // withCredentials: true, // 跨域请求时发送 cookies by maliang
                //最大超时时间
                timeout: 600000,
                //服务端返回数据类型。
                responseType: 'text'
            }).then(function(response) {
                fn(response)
            }).catch(function(error) {
                console.log("Axios异常：", error);
            });
        },
        handleResponse: function(response, fn) {
            if (!response.data.succeed) {
                if (response.data.code == 401) { //若果是token过期，或者session过期，都会返回401
                    Operation.Variable.notifyCount++ //通知计数自增
                    // if (Operation.Variable.notifyCount <= 1) { //如果通知数小于等于1，则显示通知，否则不显示，避免多次弹出踢出通知
                    //     Notification({ //弹出框提示用户
                    //         title: "警告",
                    //         message: "登录状态已过期，请重新登录",
                    //         duration: 0,
                    //         type: 'warning'
                    //     })
                    //     Store.commit('setDialogVisible', true)
                    // }
                    Operation.SessionStorage.delete('token')
                    Operation.LocalStorage.delete('token')
                    Store.commit('setUserInfo', null)
                    if(window.location.pathname.startsWith('/roborobo/')) {
                        Router.push('login');
                    } else {
                        Store.commit('setLoginBtnShow', true)
                    }
                    
                    // let path = Router.currentRoute.fullPath
                } else if (response.data.code == 403) { //如果同一个账号重复登录次数超出最大允许值，被服务器踢出来了，返回403
                    Operation.Variable.notifyCount++ //通知计数自增
                        if (Operation.Variable.notifyCount <= 1) { //如果通知数小于等于1，则显示通知，否则不显示，避免多次弹出踢出通知
                            Notification({ //弹出框提示用户
                                title: "警告",
                                message: response.data.msg,
                                duration: 0,
                                type: 'warning'
                            })
                        }
                    Operation.SessionStorage.delete('token')
                    Operation.LocalStorage.delete('token')
                    Store.commit('setUserInfo', null)
                    if(window.location.pathname.startsWith('/roborobo/')) {
                        Router.push('login');
                    } else {
                        Store.commit('setLoginBtnShow', true)
                    }

                    // let path = Router.currentRoute.fullPath
                } else {
                    Message({
                        message: response.data.msg,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                fn(response.data);
                Store.dispatch('loading/endLoading')
            } else {
                if (response.data.msg && response.data.msg != '') {
                    // console.log(1)
                    // Notification({
                    //     title: "警告",
                    //     message: response.data.msg,
                    //     duration: 0,
                    //     type: 'warning'
                    // })
                }
                Store.dispatch('loading/endLoading')
                fn(response.data);
            }
        },
        //获取：Header请求头。
        getHeader: function() {
            // let token = Operation.SessionStorage.get('token');
            let token = "";
            if(Operation.LocalStorage.get('token')) {
                token = Operation.LocalStorage.get('token');
            } else if(Operation.SessionStorage.get('token')) {
                token = Operation.SessionStorage.get('token')
            }
            if(token) {
                return {
                    'Content-Type': 'application/json',
                    'token': token ? token : ''
                };
            }
            return {
                'Content-Type': 'application/json'
            };
        },
        getPostFileHeader: function() {
            // let token = Operation.SessionStorage.get('token');
            let token = "";
            if(Operation.LocalStorage.get('token')) {
                token = Operation.LocalStorage.get('token');
            } else if(Operation.SessionStorage.get('token')) {
                token = Operation.SessionStorage.get('token')
            }
            return {
                'Content-Type': 'multipart/form-data',
                'token': token ? token : ''
            };
        },
    },
    //本地缓存。
    LocalStorage: {
        prefix: '',
        //获取：本地缓存。
        get: function(key) {
            key = Operation.LocalStorage.prefix + key;
            if (!window.localStorage) return null;
            let objStr = window.localStorage.getItem(key);
            if (objStr == null) return null;
            let obj = JSON.parse(objStr);
            if (obj == null) return null;
            if (obj.time == Operation.Time.getToday()) return obj.value;
            // else {
            //     Operation.Cache.deleteCache(key);
            //     return null;
            // }
            return obj.value;
        },
        //设置：本地缓存。
        set: function(key, value) {
            key = Operation.LocalStorage.prefix + key;
            if (!window.localStorage) return;
            let obj = {
                // time: Operation.Time.getToday(),
                key: key,
                value: value
            };
            let objStr = JSON.stringify(obj);
            window.localStorage.setItem(key, objStr);
        },
        //删除：本地缓存。
        delete: function(key) {
            key = Operation.LocalStorage.prefix + key;
            if (!window.localStorage) return;
            window.localStorage.removeItem(key);
        },
    },
    //本地缓存。
    SessionStorage: {
        prefix: '',
        //获取：本地缓存。
        get: function(key) {
            key = Operation.SessionStorage.prefix + key;
            if (!window.sessionStorage) return null;
            let objStr = window.sessionStorage.getItem(key);
            if (objStr == null) return null;
            let obj = JSON.parse(objStr);
            if (obj == null) return null;
            if (obj.time == Operation.Time.getToday()) return obj.value;
            return obj.value;
        },
        //设置：本地缓存。
        set: function(key, value) {
            key = Operation.SessionStorage.prefix + key;
            if (!window.sessionStorage) return;
            let obj = {
                // time: Operation.Time.getToday(),
                key: key,
                value: value
            };
            let objStr = JSON.stringify(obj);
            window.sessionStorage.setItem(key, objStr);
        },
        //删除：本地缓存。
        delete: function(key) {
            key = Operation.SessionStorage.prefix + key;
            if (!window.sessionStorage) return;
            window.sessionStorage.removeItem(key);
        },
    },
    //时间。
    Time: {
        //获取：时间戳。
        getTimeStamp: function() {
            var dateTime = new Date();
            var dateTimeTs = dateTime.getTime().toString();
            var num = dateTimeTs.length;
            return dateTimeTs.substring(0, num - 3);
        },
        //获取：“年_月_日_时” 字符串。
        getToday: function() {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let hour = date.getHours();
            return year + '_' + month + '_' + day + '_' + hour;
        },
        //转换：现实时间 转成 距今时间。
        date2LatestDate: function(strdata) {
            // dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
            let minute = 1000 * 60; // 把分，时，天，周，半个月，一个月用毫秒表示
            let hour = minute * 60;
            let day = hour * 24;
            let week = day * 7;
            // let halfamonth = day * 15
            let month = day * 30;
            let dateTimeStamp = Date.parse(strdata);
            let now = new Date().getTime();
            let diffValue = now - dateTimeStamp; // 时间差
            if (diffValue < 0) return strdata;

            // 计算时间差的分，时，天，周，月
            let minC = diffValue / minute;
            let hourC = diffValue / hour;
            let dayC = diffValue / day;
            let weekC = diffValue / week;
            let monthC = diffValue / month;

            if (monthC >= 1 && monthC <= 12) return '' + parseInt(monthC) + '月前';
            if (weekC >= 1 && weekC <= 4) return '' + parseInt(weekC) + '周前';
            if (dayC >= 1 && dayC <= 7) return '' + parseInt(dayC) + '天前';
            if (hourC >= 1 && hourC <= 23) return '' + parseInt(hourC) + '小时前';
            if (minC >= 1 && minC <= 59) return '' + parseInt(minC) + '分钟前';
            if (diffValue >= 0 && diffValue <= minute) return '刚刚';
            else {
                // var datetime = new Date()
                // datetime.setTime(dateTimeStamp);
                // var Nyear = datetime.getFullYear();
                // var Nmonth = datetime.getMonth() + 1 < 10 ? '0' + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
                // var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                // var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                // var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                // var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                // result = Nyear + "-" + Nmonth + "-" + Ndate
                // return '2018-04-09 09:21:16'.substring(0, '2018-04-09 09:21:16'.indexOf(' '))
                return strdata;
            }
        },
    },
};

export default Operation;


// WEBPACK FOOTER //
// ./src/request/index.js